module.exports = __webpack_public_path__ + "static/media/back-icon.ac057627.svg";